module.exports = __webpack_public_path__ + "img/logo--light.4aab2a15.svg";